import type { SvgProps } from "replo-utils/react/components";

import * as React from "react";

import { Svg } from "replo-utils/react/components";

const Message = (props: SvgProps) => (
  <Svg width={22} height={22} viewBox="0 0 22 22" fill="none" {...props}>
    <g filter="url(#message_filter)">
      <path
        d="M11.4995 4.5C10.3773 4.49976 9.2741 4.79006 8.29737 5.34264C7.32065 5.89523 6.50362 6.69128 5.92582 7.65331C5.34803 8.61534 5.02914 9.71058 5.00021 10.8324C4.97127 11.9543 5.23328 13.0645 5.76072 14.055L5.05134 16.1831C4.99258 16.3593 4.98405 16.5484 5.02671 16.7292C5.06937 16.9099 5.16154 17.0753 5.29287 17.2066C5.42421 17.3379 5.58952 17.4301 5.7703 17.4728C5.95107 17.5154 6.14014 17.5069 6.31634 17.4481L8.44447 16.7388C9.3162 17.2024 10.2821 17.4614 11.2689 17.496C12.2556 17.5306 13.2373 17.34 14.1394 16.9386C15.0415 16.5372 15.8402 15.9355 16.4751 15.1793C17.1099 14.4231 17.5642 13.5322 17.8033 12.5742C18.0424 11.6162 18.0602 10.6164 17.8552 9.65052C17.6502 8.68467 17.2279 7.77821 16.6202 6.99995C16.0126 6.22169 15.2357 5.59208 14.3484 5.15891C13.4611 4.72574 12.4868 4.50041 11.4995 4.5ZM8.74947 11.75C8.60113 11.75 8.45613 11.706 8.33279 11.6236C8.20945 11.5412 8.11332 11.4241 8.05656 11.287C7.99979 11.15 7.98494 10.9992 8.01388 10.8537C8.04282 10.7082 8.11425 10.5746 8.21914 10.4697C8.32402 10.3648 8.45766 10.2933 8.60315 10.2644C8.74863 10.2355 8.89943 10.2503 9.03648 10.3071C9.17352 10.3639 9.29066 10.46 9.37307 10.5833C9.45548 10.7067 9.49946 10.8517 9.49946 11C9.49946 11.1989 9.42045 11.3897 9.2798 11.5303C9.13914 11.671 8.94838 11.75 8.74947 11.75ZM11.4995 11.75C11.3511 11.75 11.2061 11.706 11.0828 11.6236C10.9595 11.5412 10.8633 11.4241 10.8066 11.287C10.7498 11.15 10.7349 10.9992 10.7639 10.8537C10.7928 10.7082 10.8642 10.5746 10.9691 10.4697C11.074 10.3648 11.2077 10.2933 11.3531 10.2644C11.4986 10.2355 11.6494 10.2503 11.7865 10.3071C11.9235 10.3639 12.0407 10.46 12.1231 10.5833C12.2055 10.7067 12.2495 10.8517 12.2495 11C12.2495 11.1989 12.1704 11.3897 12.0298 11.5303C11.8891 11.671 11.6984 11.75 11.4995 11.75ZM14.2495 11.75C14.1011 11.75 13.9561 11.706 13.8328 11.6236C13.7095 11.5412 13.6133 11.4241 13.5566 11.287C13.4998 11.15 13.4849 10.9992 13.5139 10.8537C13.5428 10.7082 13.6142 10.5746 13.7191 10.4697C13.824 10.3648 13.9577 10.2933 14.1031 10.2644C14.2486 10.2355 14.3994 10.2503 14.5365 10.3071C14.6735 10.3639 14.7907 10.46 14.8731 10.5833C14.9555 10.7067 14.9995 10.8517 14.9995 11C14.9995 11.1989 14.9204 11.3897 14.7798 11.5303C14.6391 11.671 14.4484 11.75 14.2495 11.75Z"
        fill="url(#message_gradient)"
      />
    </g>
    <defs>
      <filter
        id="message_filter"
        x="4.85476"
        y="4.21343"
        width="14.0737"
        height="13.2866"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />

        {/* Simplified inner shadow effects */}
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-0.143284" dy="-0.167164" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.937255 0 0 0 0 0.0980392 0 0 0 0 0.431373 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="shape" result="shadow1" />

        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha2"
        />
        <feOffset dx="0.931343" dy="-0.286567" />
        <feGaussianBlur stdDeviation="0.4" />
        <feComposite in2="hardAlpha2" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.501961 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="shadow1" result="shadow2" />

        {/* Simplified noise effect */}
        <feTurbulence
          type="fractalNoise"
          baseFrequency="40"
          numOctaves="2"
          result="noise"
          seed="2877"
        />
        <feColorMatrix in="noise" type="luminanceToAlpha" result="alphaNoise" />
        <feFlood floodColor="rgba(239, 25, 110, 0.3)" result="noiseColor" />
        <feComposite
          operator="in"
          in2="alphaNoise"
          in="noiseColor"
          result="coloredNoise"
        />
        <feComposite
          operator="multiply"
          in2="shadow2"
          in="coloredNoise"
          result="finalNoise"
        />

        <feMerge>
          <feMergeNode in="shadow2" />
          <feMergeNode in="finalNoise" />
        </feMerge>
      </filter>

      <linearGradient
        id="message_gradient"
        x1="0.27559"
        y1="19.2388"
        x2="17.2905"
        y2="5.20896"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EF196E" />
        <stop offset="0.533654" stopColor="#FFEB80" />
        <stop offset="1" stopColor="#274AE2" />
      </linearGradient>
    </defs>
  </Svg>
);

export default Message;
